// @flow

import ally from "ally.js";
import YoutubeEmbed from "./youtube-embed";
import PubSub from "./util/pubsub";

class Lightbox {
    el: HTMLElement;
    openers: Array<HTMLElement>;
    id: string;
    closeBtn: ?HTMLElement;
    allyHandler: ?{ disengage: () => {} };
    previouslyFocusedElement: ?HTMLElement;
    lightboxContainer: ?HTMLElement;
    youtubeEmbed: ?HTMLElement;
    player: ?YoutubeEmbed;
    mediaGallery: ?HTMLElement;

    constructor(el: HTMLElement) {
        this.el = el;
        this.id = this.el.getAttribute("id") || "";
        this.closeBtn = el.querySelector(".lightbox__close-btn");
        this.lightboxContainer = document.querySelector(".page");

        // Append (move) lightbox to the lightboxContainer
        if (this.lightboxContainer) {
            this.lightboxContainer.append(this.el);
        }

        if (!this.id) {
            return;
        }

        this.openers = Array.from(
            document.querySelectorAll(`[data-lightbox-open='${this.id}']`)
        );

        // Save refences to any youtube embeds inside the lightbox
        this.youtubeEmbed = this.el.querySelector(".youtube-embed__player");

        // Save refernces to any media-galleries
        this.mediaGallery = this.el.querySelector(".media-gallery");

        this.attachHandlers();
    }

    attachHandlers = () => {
        window.addEventListener("keyup", (event: KeyboardEvent) => {
            if (event.key === "Enter") {
                if (event.target instanceof HTMLElement) {
                    const selector = `[data-lightbox-open='${this.id}']`;
                    if (event.target.matches(`${selector}, ${selector} *`)) {
                        event.preventDefault();
                        this.open();
                    }
                }
            }
        });

        window.addEventListener("click", (event: MouseEvent) => {
            if (event.target instanceof HTMLElement) {
                const selector = `[data-lightbox-open='${this.id}']`;
                if (event.target.matches(`${selector}, ${selector} *`)) {
                    event.preventDefault();
                    this.open();
                }
            }
        });

        if (this.closeBtn) {
            this.closeBtn.addEventListener("click", () => {
                this.close();
            });
        }

        window.addEventListener("keyup", this.handleEscapeToClose);

        PubSub.subscribe("lightbox", (event: any) => {
            if (event.id === this.id && event.type === "openLightbox") {
                this.open();
            }
        });

        PubSub.subscribe("datepicker", (event: any) => {
            if (event.id === this.id && event.type === "dateSelection") {
                this.close();
            }
        });
    };

    open = () => {
        if (this.el.classList.contains("active")) {
            return;
        }
        this.el.classList.add("active");
        requestAnimationFrame(() => {
            this.allyHandler = ally.maintain.disabled({
                filter: this.el,
            });
        });
        // Save the current focused item
        this.previouslyFocusedElement = document.activeElement;

        const embed = this.el.querySelector(".youtube-embed__player");
        if (embed) {
            this.player = new YoutubeEmbed(embed);
        }
    };

    close = () => {
        this.el.classList.remove("active");

        requestAnimationFrame(() => {
            if (this.allyHandler) {
                this.allyHandler.disengage();
                if (this.previouslyFocusedElement) {
                    this.previouslyFocusedElement.focus();
                }
            }
        });

        // Find and destroy any youtube_embed players whenever a lightbox is closed
        if (this.player) {
            this.player.destroy();
        }
    };

    handleEscapeToClose = (event: KeyboardEvent) => {
        if (event.key === "Escape" || event.key === "Esc") {
            this.close();
        }
    };
}

const els = document.querySelectorAll(".lightbox");
els.forEach((el: HTMLElement) => {
    new Lightbox(el);
});
